import { Path, Svg, SVGProps } from "@react-pdf/renderer";

export const HealthIcon = (props: SVGProps) => (
  <Svg {...props} viewBox="0 0 28 28">
    <Path
      d="M17.6874 16.9658C19.2781 16.9658 20.5676 15.6933 20.5676 14.1235C20.5676 12.5538 19.2781 11.2812 17.6874 11.2812C16.0967 11.2812 14.8072 12.5538 14.8072 14.1235C14.8072 15.6933 16.0967 16.9658 17.6874 16.9658ZM17.6874 16.9658C15.1423 16.9658 13.0791 18.4929 13.0791 20.3766M17.6874 16.9658C20.2325 16.9658 22.2957 18.4929 22.2957 20.3766"
      fill="none"
      strokeWidth="1.94034"
      strokeLinecap="round"
    />
    <Path
      d="M10.3124 13.7589C11.9031 13.7589 13.1926 12.4015 13.1926 10.7271C13.1926 9.05269 11.9031 7.69531 10.3124 7.69531C8.72172 7.69531 7.43222 9.05269 7.43222 10.7271C7.43222 12.4015 8.72172 13.7589 10.3124 13.7589ZM10.3124 13.7589C7.76731 13.7589 5.7041 15.3877 5.7041 17.397M10.3124 13.7589C12.8575 13.7589 14.9207 15.3877 14.9207 17.397"
      fill="none"
      strokeWidth="1.94034"
      strokeLinecap="round"
    />
  </Svg>
);
